<!--
 * @Description: 404页面组件
 * @Author: lixuan
 * @Date: 2020-03-16 15:19:47
 * @LastEditors: lixuan
 * @LastEditTime: 2020-05-07 17:56:03
 -->
<template>
    <div class="page-404-wrp">
        <div class="section">
            <img src="@assets/images/404.png" alt="" />
            <h1 class="title">404</h1>
        </div>
    </div>
</template>

<script>
import { off as offStatus } from '@/util/status-util'

export default {
    name: 'notFound',
    mounted() {
        offStatus('loading')
    },
}
</script>

<style lang="scss" scoped>
.page-404-wrp{
    width: 100%;
    height: 100%;
    position: relative;
    .section{
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .title{
            width: 100%;
            text-align: center;
            font-size: 24px;
            letter-spacing: 10px;
            line-height: 44px;
        }
        img{
            width: 90%;
            max-width: 500px;
            display: block;
            margin: 0 auto;
        }
    }
}
</style>
